module.exports = __webpack_public_path__ + "static/candies-463d31467d2505ea048f1c215580426d.png";